import React, { useRef } from "react";
import "./CourseBundleSection.css";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const bundleVideos = [
  "/media/main.mp4",
  "/media/main3.mp4",
  "/media/main4.mp4",
];

export default function CourseBundleSection() {
  const videoRefs = useRef<(HTMLVideoElement | null)[]>([]);
  const swiperRef = useRef<any>(null);

  // Pause all videos on slide change
  const handleSlideChange = () => {
    videoRefs.current.forEach((video) => {
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    });
  };

  return (
    <section className="course-bundle-section">
      <div className="course-bundle-content">
      <div className="course-bundle-image">
          <div className="swiper-container-wrapper">
            <Swiper
              spaceBetween={32}
              slidesPerView={1}
              loop={false}
              modules={[Navigation, Autoplay, Pagination]}
              className="course-bundle-videos-swiper"
              style={{ paddingBottom: 40 }}
              pagination={{ clickable: true }}
              navigation={{
                prevEl: '.custom-swiper-button-prev',
                nextEl: '.custom-swiper-button-next',
              }}
              onSlideChange={handleSlideChange}
              onSwiper={swiper => {
                swiperRef.current = swiper;
                setTimeout(() => handleSlideChange(), 0);
              }}
            >
              {bundleVideos.map((src, idx) => (
                <SwiperSlide key={idx}>
                  <video
                    ref={el => { videoRefs.current[idx] = el; }}
                    src={src}
                    controls
                    loop
                    muted
                    playsInline
                    className="course-bundle-video"
                    aria-label={`Course bundle preview video ${idx + 1}`}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
            
            {/* Custom Navigation Buttons */}
            <button className="custom-swiper-button-prev" aria-label="Previous video">
              <ChevronLeft size={20} />
            </button>
            <button className="custom-swiper-button-next" aria-label="Next video">
              <ChevronRight size={20} />
            </button>
          </div>
        </div>
        <div className="course-bundle-details">
          <h3>
            If you're ready to create viral social media content and work with
            the biggest brands in the world, let's get started today.:
          </h3>
          <ul>
            <li>
              <span className="checkmark">✔</span>
              Create viral content for TikTok & Reels
            </li>
            <li>
              <span className="checkmark">✔</span>
              Master the TikTok/Reels algorithm
            </li>
            <li>
              <span className="checkmark">✔</span>
              Find a repeatable format to break 100k views every time
            </li>
            <li>
              <span className="checkmark">✔</span>
              Reach the most people possible with your content
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}
